import { render, staticRenderFns } from "./AccountProjectsOrgaWaitingForReview.vue?vue&type=template&id=35969153&"
import script from "./AccountProjectsOrgaWaitingForReview.vue?vue&type=script&lang=ts&"
export * from "./AccountProjectsOrgaWaitingForReview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports